export default __webpack_public_path__ + "static/media/Roboto-MediumItalic.8b2a5c88.ttf";